import { CraneChildItem } from '@shared/types/CraneTypes';
import { useTranslations } from '@shared/context/useTranslations';
import { cn } from '@shared/helpers/classNames.helper';
import S from './CraneChildItemList.module.scss'

interface CraneChildItemListProps {
    items: CraneChildItem[];
    isPdP?: boolean;
}
export const CraneChildItemList = ({ items, isPdP = false }: CraneChildItemListProps) => {
    const { getTranslation} = useTranslations();

    return (
        <div className={cn(S.itemGrid, isPdP ? S.pdpGrid : S.nonPdpGrid)}>
            <div className={cn(S.itemRow, S.itemHeaderRow)}>
                <div>{getTranslation('crane.child-items.id')}</div>
                <div>{getTranslation('crane.child-items.name')}</div>
                <div>{getTranslation('crane.child-items.quantity')}</div>
            </div>

            {items.map((item) => (
                <div key={item.itemId} className={S.itemRow}>
                    <div>{item.itemId}</div>
                    <div>{item.itemName}</div>
                    <div>{item.quantity}</div>
                </div>
            ))}
        </div>
    );
}
